import React from 'react';
import { SegmentAnything } from '../SegmentAnything/SegmentAnything';

export const ReplaceBackgroundSegmentAnything = ({ setSegmentMask, className }) => {
    return <SegmentAnything bodyClassName={className} setSegmentMask={setSegmentMask} />;
};
